import Button from '../UI/Button';
import LoadingSpinner from '../UI/LoadingSpinner';

export default function NavigationButtons({
  onBack,
  onNext,
  canGoBack = true,
  canProceed = false,
  isLoading = false,
  nextLabel = 'Continue',
  backLabel = '←'
}) {
  return (
    <div className="flex gap-4 mt-8">
      {canGoBack && (
        <Button
          onClick={onBack}
          variant="ghost"
          disabled={isLoading}
          className="w-1/4"
        >
          {backLabel}
        </Button>
      )}

      <Button
        onClick={onNext}
        variant="primary"
        disabled={isLoading || !canProceed}
        className={canGoBack ? 'w-3/4' : 'w-full'}
      >
        {isLoading ? (
          <div className="flex items-center justify-center gap-3">
            <LoadingSpinner size="sm" />
            <span>Processing...</span>
          </div>
        ) : (
          nextLabel
        )}
      </Button>
    </div>
  );
}
